export default "https://cdn-static.gokick.com/assets/4e3548e0bbc963e39203d4ae4090204efad0894d/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";